/**
 6* @param {Object} obj
 * @returns {string}
 */
export function getLang(obj, className) {
  className = className ? className : "";
  const locale = localStorage.getItem("tfl-lang") || "en";
  // console.log(obj[locale]);
  return obj[locale] + " " + className;
}



// WEBPACK FOOTER //
// ./src/utils/index.js